//import { captureException } from '@sentry/react';
import { throttle } from 'lodash';
import { wait } from '../../../../helpers/jsHelper';
import { dispatcher } from '../../../../helpers/projectHelper';
import { errorToast } from '../../../../helpers/toastHelper';
import { curatorLoaderActions } from '../../../../redux/slicers/admin/curatorLoaderSlicer';
import {
  selectOpenAlignmentTool,
  selectSidebarSection,
  setCuratorLoader,
} from '../../../../redux/slicers/admin/curatorSlicer';
import { UndoRedoCamera } from './UndoRedoCamera';
import { UndoRedoCuratorSettings } from './UndoRedoCuratorSettings';
import { UndoRedoEnvironmentLight } from './UndoRedoEnvironmentLight';
import { UndoRedoFov } from './UndoRedoFov';
import { UndoRedoLight } from './UndoRedoLight';
import { UndoRedoMetadata } from './UndoRedoMetadata';
import { UndoRedoObjectProperties } from './UndoRedoObjectProperties';
import { UndoRedoSafeCameraResolution } from './UndoRedoSafeCameraResolution';
import { UndoRedoUnityObject } from './UndoRedoUnityObject';
import { UndoRedoColorSwatches } from './UndoRedoColorSwatches';
import { setCuratorNotSaved } from '../../../../pages/admin/curator/curatorState';
import { UndoRedoAutomation } from './UndoRedoAutomation';
import { UndoRedoConfiguratorTransformationPanel } from './UndoRedoConfiguratorTransformationPanel';
import { UndoRedoConfiguratorCameraValues } from './UndoRedoConfiguratorCameraValues';
import { UndoRedoProductBuilder } from './UndoRedoProductBuilder';
import { UndoRedoTopBottom } from './UndoRedoTopBottom';
import { UndoRedoTape } from './UndoRedoTape';
import { UndoRedoWall } from './UndoRedoWall';
import { UndoRedoLayer } from './UndoRedoLayer';
import { LogCurator } from '../../../../helpers/logEvents';
import { UndoRedoTileGrout } from './UndoRedoTileGrout';
import { UndoRedoView } from './UndoRedoView';
import { UndoRedoCutaway } from './UndoRedoCutaway';
import { UndoRedoButton } from './UndoRedoButton';
import { getAppState } from '../../../../redux/store';
import { selectShowInfoWarningPopup } from '../../../../redux/slicers/admin/curatorUnityObjectSlicer';
import { isMattressBuilderPage } from '../ProductBuilderComponents/commonHelper';
import { CURATOR_MENU_SECTION } from '../../../../redux/slicers/admin/curatorMenuPreferencesSlicer';
import { MAX_MATTRESS_BUILDER_UNDO_REDO_STACK_SIZE } from '../../../../constants/constants';

// const ACTION = {
//   SELECT_OBJECT: 'SELECT_OBJECT',
//   DELETE_OBJECT: 'DELETE_OBJECT',
//   CHANGE_FOV: 'CHANGE_FOV',
// };

export class UndoRedo {
  constructor() {
    this.history = new LinkedList();
    this.currentItem = 'tail';
    this.lastAction = null;
    this.skipActionList = [];
    this.inprogress = false;
    this.saveBackupTimeoutId = null;
  }

  setUnityContext = (unityContext) => {
    this.unityContext = unityContext;
  };

  setUnityLight = (unityLight) => {
    this.unityLight = unityLight;
  };

  setUnityHDRI = (unityHDRI) => {
    this.unityHDRI = unityHDRI;
  };

  setUnityRedux = (unityRedux) => {
    this.unityRedux = unityRedux;
  };

  setUnityColor = (unityColor) => {
    this.unityColor = unityColor;
  };

  setUnityCameraFields = (unityCameraFields) => {
    this.unityCameraFields = unityCameraFields;
  };

  setUnityMaterial = (unityMaterial) => {
    this.unityMaterial = unityMaterial;
  };

  setUnityShortcuts = (unityShortcuts) => {
    this.unityShortcuts = unityShortcuts;
  };

  setUnityMetadata = (unityMetadata) => {
    this.unityMetadata = unityMetadata;
  };

  setUnityAutomation = (unityAutomation) => {
    this.unityAutomation = unityAutomation;
  };

  _getHistoryStats = () => {
    const nodes = [];
    let n = this.history.head;
    while (n) {
      nodes.push(n);
      n = n.next;
    }
    const total = nodes.length;
    let currentIndex;
    if (this.currentItem === 'head') currentIndex = -1;
    else if (this.currentItem === 'tail') currentIndex = total - 1;
    else currentIndex = nodes.indexOf(this.currentItem);
    let undoCount = currentIndex + 1;
    if (undoCount < 0) undoCount = 0;
    let redoCount = total - (currentIndex + 1);
    if (currentIndex === -1) redoCount = total;
    return {
      total,
      currentIndex,
      undoCount,
      redoCount,
      lastAction: this.lastAction,
      actions: nodes.map((node, i) => ({
        i,
        action: node.value.__ACTION__,
        id: node.value._id,
      })),
    };
  };

  _logStacks = (label) => {
    const s = this._getHistoryStats();
    LogCurator(
      `[UndoRedo][STACK] ${label} | total=${s.total} undo=${s.undoCount} redo=${s.redoCount} currentIndex=${s.currentIndex} lastAction=${s.lastAction}`,
      s.actions
    )
  };

  resetHistory = () => {
    this.paused = false;
    this.inprogress = false;
    this.history = new LinkedList();
    this.currentItem = 'tail';
    this.lastAction = null;
    this.objectProperties?.unsubscribe();
    this.unityObject?.unsubscribe();
    this.skipActionList = [];
    this.productBuilder?.clearAllPendingChanges?.();
    this.topBottom?.clearAllPendingChanges?.();
    this.tape?.clearAll?.();
    this.wall?.clearAllPendingChanges?.();
    this.layer?.clearAllPendingChanges?.();
    this.view?.clearAll?.();
    this.cutaway?.clearAll?.();
    this.button?.clearAll?.();
    this.init();
    this._logStacks('after resetHistory');
  };

  pause = () => {
    this.paused = true;
  };

  resume = () => {
    this.paused = false;
  };

  handleUndoRedoError = () => {
    dispatcher(setCuratorLoader(true));
    dispatcher(curatorLoaderActions.resetState());
    this.resetHistory();
  };

  saveBackup = () => {
    clearTimeout(this.saveBackupTimeoutId);

    this.saveBackupTimeoutId = setTimeout(() => {
      setCuratorNotSaved({ saveTempData: true });
    }, 600);
  };

  undo = throttle(async () => {
    if (!this.currentItem) return;
    if (this.currentItem === 'head') return;
    if (this.inprogress) {
      LogCurator('sasha undoooo UNDO BLOCKED!!!!!!!!');
      return;
    }
    const isAlignmentToolOpen = selectOpenAlignmentTool(getAppState());
    const isAlignmentToolWarning = selectShowInfoWarningPopup(getAppState());
    if (isAlignmentToolOpen || isAlignmentToolWarning) return;

    const item = this.currentItem === 'tail' ? this.history.tail : this.currentItem;

    if (!item) {
      // this is case when history is empty
      return;
    }

    clearTimeout(this.saveBackupTimeoutId);
    this.inprogress = true;

    if (window.DEBUG_UNDO_REDO) {
      const ACTION = item.value.__ACTION__;
      // eslint-disable-next-line
      debugger;
    }

    if (item.value.__PAUSE) {
      this.pause(); // pause history before action
    }

    let isError = false;
    try {
      await item.value.undo();
    } catch (e) {
      //captureException(e);
      console.error(e);
      errorToast('Error happened during undo. LF_324288');
      isError = true;
    }
    if (item.value.__PAUSE) {
      this.resume(); // resume history before action
    }

    this.currentItem = item.prev || 'head';
    this.lastAction = 'undo';

    await wait(50); // wait for other actions to complete fully ???? // TODO: work on it so we know from unity end that action has ended
    this.inprogress = false;

    setCuratorNotSaved({ saveTempData: false });
    this.saveBackup();

    this._logStacks('after undo');

    if (isError) {
      this.handleUndoRedoError();
    }
  }, 20);

  redo = throttle(async () => {
    // console.log('UNDOREDO redo', this)
    if (!this.currentItem) return;
    if (this.currentItem === 'tail') return;
    if (this.inprogress) return;

    const isAlignmentToolOpen = selectOpenAlignmentTool(getAppState());
    const isAlignmentToolWarning = selectShowInfoWarningPopup(getAppState());
    if (isAlignmentToolOpen || isAlignmentToolWarning) return;

    const item = this.currentItem === 'head' ? this.history.head : this.currentItem.next;

    if (!item) {
      this.currentItem = 'tail';
      return;
    }

    clearTimeout(this.saveBackupTimeoutId);
    this.inprogress = true;

    if (window.DEBUG_UNDO_REDO) {
      const ACTION = item.value.__ACTION__;
      // eslint-disable-next-line
      debugger;
    }

    if (item.value.__PAUSE) this.pause(); // pause history before action
    let isError = false;
    try {
      await item.value.redo();
    } catch (e) {
      //captureException(e);
      console.error(e);
      errorToast('Error happened during redo. LF_3242889');
      isError = true;
    }
    if (item.value.__PAUSE) this.resume(); // resume history before action

    this.currentItem = item;
    this.lastAction = 'redo';
    await wait(50); // wait for other actions to complete fully ???? // TODO: work on it so we know from unity end that action has ended
    this.inprogress = false;

    setCuratorNotSaved({ saveTempData: false });
    this.saveBackup();

    this._logStacks('after redo');

    if (isError) {
      this.handleUndoRedoError();
    }
  }, 20);

  stopWatchingAction = (actionName) => {
    this.skipActionList.push(actionName);
  };

  continueWatchingAction = (actionName) => {
    this.skipActionList = this.skipActionList.filter((n) => n !== actionName);
  };

  getCurrentNode = () => {
    if (this.currentItem === 'head') {
      // it means that we're currently undone the first item, so current item is null
      return null;
    }
    if (this.currentItem === 'tail') return this.history.tail;

    if (this.lastAction === 'undo') {
      return this.currentItem;
    }

    if (this.lastAction === 'redo') {
      return this.currentItem;
    }

    throw new Error('Unable to get current history node');
  };

  removeLastEntry = () => {
    this.history.pop();
  };

  getHistoryStats = () => this._getHistoryStats(); // public helper

  createAction =
    (func, { pause, name } = {}) =>
      async (...args) => {
        const sidebarActiveSection = selectSidebarSection(getAppState());
        // Block while undo/redo in progress to avoid stack corruption
        if (this.inprogress) {
          if (window.DEBUG_UNDO_REDO) {
            console.log('[UndoRedo] Ignored action during inprogress:', name);
          }
          return;
        }
        if (this.paused) return;

        // Fix skip list check
        if (name && this.skipActionList.includes(name)) {
          if (window.DEBUG_UNDO_REDO) {
            console.log('[UndoRedo] Skipped action via skipActionList:', name);
          }
          return;
        }

        const newHistoryValue = await func(...args);
        if (!newHistoryValue) return;

        if (pause) {
          newHistoryValue.__PAUSE = true;
        }

        if(isMattressBuilderPage() && sidebarActiveSection !== CURATOR_MENU_SECTION.STYLE && (!newHistoryValue.__ACTION__ || newHistoryValue.__ACTION__ === 'undefined' || newHistoryValue.__ACTION__ === undefined || newHistoryValue.__ACTION__ === "UNITY_OBJECT__ADD_PROP")) {
          return
        }

        LogCurator('CREATE_ACTION', newHistoryValue);

        const currentNode = this.getCurrentNode();
        this.history.pushValue(newHistoryValue, currentNode);
        this.currentItem = 'tail';
        this.lastAction = null;
        this._logStacks('after push');
      };

  createSimpleAction = ({ changeStateAction }) => {
    return this.createAction(({ prevValue, nextValue } = {}) => {
      return {
        undo: () => {
          changeStateAction(prevValue);
        },
        redo: () => {
          changeStateAction(nextValue);
        },
      };
    });
  };

  init = () => {
    // TODO: come up with better undo/redo base class
    this.fov = new UndoRedoFov({ unityContext: this.unityContext, undoRedoInstance: this });
    this.safeCameraResolution = new UndoRedoSafeCameraResolution({ undoRedoInstance: this });
    this.settings = new UndoRedoCuratorSettings({
      undoRedoInstance: this,
      unityContext: this.unityContext,
    });
    this.colorSwatches = new UndoRedoColorSwatches({ undoRedoInstance: this });
    this.automation = new UndoRedoAutomation({
      undoRedoInstance: this,
      unityAutomation: this.unityAutomation,
    });
    this.configuratorTransformationPanel = new UndoRedoConfiguratorTransformationPanel({
      unityContext: this.unityContext,
      undoRedoInstance: this,
    });
    this.configuratorCameraValues = new UndoRedoConfiguratorCameraValues({
      unityContext: this.unityContext,
      undoRedoInstance: this,
    });
    if (this.unityLight) {
      this.light = new UndoRedoLight({ undoRedoInstance: this, unityLight: this.unityLight });
    }
    if (this.unityHDRI) {
      this.environmentLight = new UndoRedoEnvironmentLight({
        undoRedoInstance: this,
        unityHDRI: this.unityHDRI,
      });
    }
    if (this.unityRedux) {
      this.objectProperties = new UndoRedoObjectProperties({
        undoRedoInstance: this,
        unityObjectProperties: this.unityRedux,
        unityColor: this.unityColor,
        unityContext: this.unityContext,
        unityMaterial: this.unityMaterial,
      });
    }
    if (this.unityShortcuts) {
      this.unityObject = new UndoRedoUnityObject({
        undoRedoInstance: this,
        unityContext: this.unityContext,
        unityShortcuts: this.unityShortcuts,
      });
    }
    if (this.unityCameraFields) {
      this.camera = new UndoRedoCamera({
        undoRedoInstance: this,
        unityCameraFields: this.unityCameraFields,
        unityContext: this.unityContext,
      });
    }
    if (this.unityMetadata) {
      this.metadata = new UndoRedoMetadata({
        undoRedoInstance: this,
        unityMetadata: this.unityMetadata,
      });
    }
    this.tileGrout = new UndoRedoTileGrout({
      undoRedoInstance: this,
      unityContext: this.unityContext,
    });
    this.productBuilder = new UndoRedoProductBuilder({
      undoRedoInstance: this,
    });
    this.topBottom = new UndoRedoTopBottom({
      undoRedoInstance: this,
    });
    this.tape = new UndoRedoTape({
      undoRedoInstance: this,
    });
    this.wall = new UndoRedoWall({
      undoRedoInstance: this,
    });
    this.layer = new UndoRedoLayer({
      undoRedoInstance: this,
    });
    this.view = new UndoRedoView({
      undoRedoInstance: this,
    });
    this.cutaway = new UndoRedoCutaway({
      undoRedoInstance: this,
    });
    this.button = new UndoRedoButton({
      undoRedoInstance: this,
    });
  };
}

class Node {
  constructor(value, prev, next = null) {
    this.value = value;
    this.prev = prev;
    this.next = next;
  }
}

class LinkedList {
  // this linked list will work only for undo/redo, do not use it in different places

  constructor() {
    this.head = null;
    this.tail = null;
  }

  getSize = () => {
    let count = 0;
    let current = this.head;
    while (current) {
      count++;
      current = current.next;
    }
    return count;
  };

  pushValue = (value, afterNode) => {
    const prev = afterNode;
    const newNode = new Node(value, prev);

    if (prev) {
      prev.next = newNode;
    }

    if (prev === null) {
      this.head = newNode;
    }

    this.tail = newNode;

    // Check if we need to limit stack size for mattress builder page
    if (isMattressBuilderPage()) {
      const currentSize = this.getSize();
      if (currentSize > MAX_MATTRESS_BUILDER_UNDO_REDO_STACK_SIZE) {
        // Remove the oldest entry (from head)
        if (this.head && this.head.next) {
          this.head = this.head.next;
          this.head.prev = null;
        }
      }
    }
  };

  pop = () => {
    if (!this.tail) return;

    if (this.tail?.value?.cancel) {
      this.tail?.value?.cancel();
    }

    if (this.tail?.prev) {
      const prev = this.tail.prev;
      this.tail = prev;
      prev.next = null;
    } else {
      this.tail = null;
      this.head = null;
    }
  };
}

export const undoRedo = new UndoRedo();

window.undoRedo = undoRedo;
